<template>
  <div id="userLogin">
    <div class="query-container">
      <!-- 优化后的标题通知 -->
      <div class="notice-wrapper">
        <div class="notice-icon">⚠️</div>
        <div class="notice-content">
          <p class="title-desc">提交更改地区后预计1个工作日内处理，处理完成后该卡仅可在提交区域使用，跨区域将无法使用！</p>
        </div>
      </div>
      <form class="query-form">
        <div class="input-wrap">
          <input type="text" v-model="iccid" placeholder="请输入卡号查询" autofocus class="iccid-input" />
        </div>
        <div class="formLine">
          <mt-button type="primary" style="background:#0066FF" size="large" @click.prevent="userQuerySIM"
            class="query-btn">
            查 询 限 制
          </mt-button>
          <mt-button type="primary" style="background:#0066FF" size="large" @click.prevent="toSubmit" class="query-btn">
            提 交 区 域
          </mt-button>
        </div>
      </form>

      <!-- 套餐列表展示区域 -->
      <div class="pkg-list" v-if="cityFlg == true">
        <h3 class="list-title">已提交数据</h3>
        <div class="pkg-card">
          <div class="pkg-item">
            <label class="label-text">提交城市：</label>
            <span class="value-text name-text">{{ cityData.city || '暂无' }}</span>
          </div>
          <div class="pkg-item">
            <label class="label-text">提交时间：</label>
            <span class="value-text flow-total">{{ cityData.createTime }}</span>
          </div>
          <span style="color: red;">注意：一个月只能处理两次</span>
        </div>
      </div>

      <!-- 无数据提示 -->
      <div class="no-data" v-if="cityFlg == false && isQuery" v-html="remark.replace(/\\n/g, '<br/>')"></div>
    </div>

    <!-- 省份选择弹窗（原生，无额外组件） -->
    <div class="province-popup-mask" v-if="provincePopupShow" @click="closeProvincePopup"></div>
    <div class="province-popup" v-if="provincePopupShow">
      <div class="popup-header">
        <h3>选择目标省份</h3>
        <span class="popup-close" @click="closeProvincePopup">×</span>
      </div>
      <div class="popup-content">
        <div class="province-item" v-for="province in provinceList" :key="province" @click="selectProvince(province)">
          {{ province }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import { wxRequest } from "@/api/user.js";
export default {
  data() {
    return {
      subCity: '', // 提交的省份（最终存储选中的省份）
      cityFlg: false,
      cityData: {
        city: "",
        createTime: ""
      },
      iccid: "",
      remark: "未提交数据",
      showAds: true,
      pkgData: [],
      isQuery: false, // 标记是否执行过查询操作
      provincePopupShow: false, // 省份选择弹窗开关
      // 全国省份/直辖市/自治区（直接写死）
      provinceList: [
        "北京市",
        "天津市",
        "上海市",
        "重庆市",
        "河北省",
        "山西省",
        "辽宁省",
        "吉林省",
        "黑龙江省",
        "江苏省",
        "浙江省",
        "安徽省",
        "福建省",
        "江西省",
        "山东省",
        "河南省",
        "湖北省",
        "湖南省",
        "广东省",
        "海南省",
        "四川省",
        "贵州省",
        "云南省",
        "陕西省",
        "甘肃省",
        "青海省",
        "台湾省",
        "内蒙古自治区",
        "广西壮族自治区",
        "西藏自治区",
        "宁夏回族自治区",
        "新疆维吾尔自治区",
        "香港特别行政区",
        "澳门特别行政区"
      ]
    };
  },
  methods: {
    // MB转换为GB，保留两位小数
    convertMBToGB(mb) {
      if (!mb || isNaN(mb)) return "0.00";
      return (mb / 1024).toFixed(2);
    },

    userQuerySIM() {
      if (!this.iccid || this.iccid == "") {
        Dialog.alert({ title: "提示", message: "请输入卡号" });
        return false;
      }

      // 清空之前的套餐数据
      this.pkgData = [];

      let data = {
        iccid: this.iccid
      };
      wxRequest("sim/cmccOutCity", data, "post").then((res) => {
        this.selectOutCity();
        this.isQuery = true;
        if (res.data.code == 200) {
          Dialog.alert({ title: "提示", message: '此卡已被限制区域使用，请您提交使用的目标区域（已提交请忽略）' });
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      }).catch((err) => {
      });
    },

    selectOutCity() {
      let data = {
        iccid: this.iccid,
        city: "1s"
      };
      wxRequest("sim/cmccOutCity/select", data, "post").then((res) => {
        if (res.data.code == 200) {
          this.cityFlg = true;
          this.cityData = res.data.data;
        }
      }).catch((err) => {
      });
    },

    // 打开省份选择弹窗
    toSubmit() {
      // 先校验卡号是否输入
      if (!this.iccid || this.iccid == "") {
        Dialog.alert({ title: "提示", message: "请先输入卡号" });
        return false;
      }
      // 打开弹窗
      this.provincePopupShow = true;
    },

    // 选择省份，赋值给subCity
    selectProvince(province) {
      let data = {
        iccid: this.iccid,
        city: province
      };
      wxRequest("sim/cmccOutCityTodata", data, "post").then((res) => {
        if (res.data.code == 200) {
          Dialog.alert({ title: "提示", message: '提交成功！' });
          this.selectOutCity();
          // 关闭弹窗
          this.provincePopupShow = false;
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      }).catch((err) => {
      });



    },

    // 关闭省份选择弹窗
    closeProvincePopup() {
      this.provincePopupShow = false;
    }
  },
  created() {
    var appid = process.env.VUE_APP_APPID;
    localStorage.setItem("appid", appid);
    localStorage.setItem("isHeadquarterAppid", true);
  },
  mounted() { },
  beforeDestroy() { }
};
</script>

<style lang="less" scoped>
// 紧急通知样式
.notice-wrapper {
  display: flex;
  align-items: flex-start;
  background: #fff8f0;
  border: 1px solid #ffd591;
  border-radius: 10px;
  padding: 16px 15px;
  margin-bottom: 20px;
  box-sizing: border-box;

  .notice-icon {
    font-size: 20px;
    margin-right: 10px;
    margin-top: 2px;
  }

  .notice-content {
    flex: 1;

    .title-desc {
      font-size: 15px;
      color: #d4380d;
      line-height: 1.6;
      margin: 0;
      word-break: break-all;
    }
  }
}

.query-container {
  padding: 0 15px;
}

// 标题样式（兼容保留，可删除）
.title {
  text-align: center;
  font-size: 18px;
  color: #0066FF;
  margin: 20px 0;
  font-weight: 700;
}

// 查询表单样式
.query-form {
  .input-wrap {
    margin-bottom: 15px;

    .iccid-input {
      width: 100%;
      padding: 12px 15px;
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      font-size: 14px;

      &:focus {
        border-color: #0066FF;
        outline: none;
      }
    }
  }

  .formLine {
    display: flex;
    gap: 10px;
  }

  .query-btn {
    flex: 1;
    height: 48px;
    line-height: 48px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    border: none;
  }
}

// 套餐列表样式
.pkg-list {
  margin-top: 25px;

  .list-title {
    font-size: 17px;
    color: #222;
    margin-bottom: 18px;
    font-weight: 600;
    position: relative;
    padding-left: 8px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 18px;
      background: #0066FF;
    }
  }

  .pkg-card {
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    .pkg-item {
      display: flex;
      margin-bottom: 12px;
      font-size: 15px;
      align-items: center;

      .label-text {
        color: #666;
        min-width: 90px;
        font-weight: 500;
      }

      .value-text {
        color: #333;
        flex: 1;

        &.name-text {
          color: #0066FF;
          font-weight: 600;
        }

        &.flow-total {
          color: #28a745;
        }

        &.flow-used {
          color: #ff7800;
        }

        &.time-text {
          color: #999;
          font-size: 14px;
        }
      }
    }

    .pkg-item:last-child {
      margin-bottom: 0;
    }
  }
}

// 无数据提示
.no-data {
  margin-top: 30px;
  text-align: left;
  font-size: 15px;
  color: #666;
  padding: 20px 25px;
  background: #f8f9fa;
  border-radius: 10px;
  white-space: pre-line;
  line-height: 1.8;

  &::before {
    content: '区域数据：';
    display: block;
    font-weight: 600;
    color: #0066FF;
    margin-bottom: 10px;
    font-size: 16px;
  }
}

.download {
  position: relative;
  top: -63px;
  background: #ff9c3c;
  border: none;
  padding: 7px 13px;
  border-radius: 25px;
  font-size: 12px;
  color: #fff;
  left: 20%;
}

// 省份弹窗样式
.province-popup-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.province-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 400px;
  background: #fff;
  border-radius: 10px;
  z-index: 1000;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  .popup-header {
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }

    .popup-close {
      font-size: 20px;
      color: #999;
      cursor: pointer;

      &:hover {
        color: #333;
      }
    }
  }

  .popup-content {
    max-height: 400px;
    overflow-y: auto;
    padding: 10px 0;

    .province-item {
      padding: 12px 20px;
      font-size: 14px;
      color: #333;
      cursor: pointer;

      &:hover {
        background: #f5f7fa;
      }

      &:not(:last-child) {
        border-bottom: 1px solid #fafafa;
      }
    }
  }
}
</style>